// Module
var code = "<div class=\"dms-filter-wrapper dms-outer-element\">\r\n    <div class=\"dms-grid-wrapper dms-filter #=data.GridName#\"></div>\r\n</div>\r\n";
// Exports
export default code;